import React from "react";
import Button from "../../atoms/Button/Button";
import { getSignupUrl } from "../../../constants/urls";

interface PricingCardProps {
  title: string;
  price: number;
  features: string[];
  isPopular?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  features,
  isPopular = false,
}) => {
  const handleRedirectToApp = () => {
    window.location.href = getSignupUrl();
  };

  return (
    <div className={`dui-pricing-card ${isPopular ? "popular" : ""}`}>
      <div className="dui-pricing-card-header">
        <h3 className="dui-pricing-card-title">{title}</h3>
        <div className="dui-pricing-card-price">
          <span className="currency">€</span>
          <span className="amount">{price}</span>
          <span className="period">/ mesiac</span>
        </div>
      </div>

      <div className="dui-pricing-card-content">
        <ul className="dui-pricing-card-features">
          {features.map((feature, index) => (
            <li key={index} className="dui-pricing-card-feature">
              {feature}
            </li>
          ))}
        </ul>
        <Button
          className="dui-pricing-card-button"
          corners="rounded"
          onClick={handleRedirectToApp}
        >
          Zakúpiť teraz
        </Button>
      </div>
    </div>
  );
};

export default PricingCard;
